// The fixed phone mask only needs the core, without aliases or legacy polyfills.
import Inputmask from "inputmask/lib/inputmask.js";

let selectors = document.querySelectorAll('[data-mask-phone]');

selectors.forEach(($selector) => {
    var im = new Inputmask("+380 (99) 999-9999");
    im.mask($selector);
});
